import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "utils__pageContainer" }
const _hoisted_2 = { class: "routeTab" }
const _hoisted_3 = { class: "statementList" }
const _hoisted_4 = { class: "statementList-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "statementList-rightTop" }, "月结账单包含：支付或退款时间发生在当前结算周期内的本期或往期订单，账单在每月1日自动生成", -1)
const _hoisted_6 = { class: "fl-row" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  href: "#",
  class: "forbid-style"
}
const _hoisted_9 = { class: "utils__pageContainer withRouteTab statementView statementView-content" }
const _hoisted_10 = { class: "statementList" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "statementList-title" }, "生成账单", -1)
const _hoisted_12 = { class: "fl-row" }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_app_enterprise_input = _resolveComponent("app-enterprise-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ReloadOutlined = _resolveComponent("ReloadOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { class: "utils__pageContainer withRouteTab statementView" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: { name: 'finance.statement' } }, {
            default: _withCtx(() => [
              _createTextVNode("账单")
            ]),
            _: 1
          }, 8, ["to"]),
          (_ctx.groupEnterpriseFlag)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'finance.group-bill' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("集团账单")
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, { to: { name: 'finance.water' } }, {
            default: _withCtx(() => [
              _createTextVNode("账户流水")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" 月结账单 "),
            _createVNode(_component_a_tooltip, { placement: "rightTop" }, {
              title: _withCtx(() => [
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  type: "question",
                  class: "icon"
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_app_table, {
            ref: "tableRef",
            size: "default",
            "row-key": "id",
            columns: _ctx.tableColumns,
            data: _ctx.loadTableData,
            "show-pagination": true,
            "page-size": 5,
            "show-size-changer": false
          }, {
            action: _withCtx(({ record }) => [
              _createElementVNode("span", _hoisted_6, [
                (record.downUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      target: "_self",
                      href: record.downUrl
                    }, "下载Excel账单", 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("a", _hoisted_8, "下载Excel账单"))
              ])
            ]),
            _: 1
          }, 8, ["columns", "data"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_a_form, {
          class: "fl-clean detailList__filterForm",
          model: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "选择时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.filterParams.timeRange[0],
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.timeRange[0]) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: "起始时间",
                  "disabled-date": _ctx.disabledStartDate
                }, null, 8, ["value", "disabled-date"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createTextVNode("~")
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { model: _ctx.filterParams }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.filterParams.timeRange[1],
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.timeRange[1]) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: "结束时间",
                  "disabled-date": _ctx.disabledEndDate
                }, null, 8, ["value", "disabled-date"])
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_app_enterprise_input, {
                  value: _ctx.filterParams.enterpriseId,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.enterpriseId) = $event)),
                  style: {"width":"180px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _ctx.createOrder
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("生成账单")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "recordNo",
          columns: _ctx.tablesColumns,
          data: _ctx.loadTablesData,
          "show-pagination": true,
          "page-size": 5,
          "show-size-changer": false
        }, {
          startTime: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(record.startTime)) + " 至 " + _toDisplayString(_ctx.formatDate(record.endTime)), 1)
          ]),
          action: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_12, [
              (record.downUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    target: "_self",
                    href: record.downUrl
                  }, "下载Excel账单", 8, _hoisted_13))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onRefreshTable && _ctx.onRefreshTable(...args)), ["prevent"]))
                  }, [
                    _createVNode(_component_ReloadOutlined)
                  ]))
            ])
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ])
    ])
  ]))
}